const _ = require('lodash');

function ReviewListingDirective() {
    return {
        restrict: 'E',
        scope: {
            reviews: '=',
            totalNumberOfReviews: '=',
            viewMoreHref: '=',
            viewMoreCount: '=?'
        },
        template: require('./review-preview-listing-template.html'),
        link(scope) {
            const MAX_COUNT = 6;
            const ON_SHOW = 2;

            const viewMoreCount = _.isUndefined(scope.viewMoreCount) ? MAX_COUNT : scope.viewMoreCount;
            const totalNumberOnShow = (viewMoreCount + ON_SHOW);
            scope.isCollapsed = true;
            scope.latestTwo = [];
            scope.viewLatest = [];

            scope.hasMoreReviews = () => {
                return scope.reviews.length > totalNumberOnShow;
            };

            scope.$watch('reviews', (reviews) => {
                if (!_.isUndefined(reviews)) {
                    scope.latestTwo = _.take(reviews, ON_SHOW);
                    scope.viewLatest = _.slice(reviews, ON_SHOW, totalNumberOnShow);
                }
            });
        }
    };
}

module.exports = ReviewListingDirective;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/list-review/review-preview-listing-directive.js
 **/